// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"LoadingIndicator_loadingWrapper__4hBVi","loadingIcon":"LoadingIndicator_loadingIcon__9DSvu","loadingBar":"LoadingIndicator_loadingBar__BB-Cj"};